import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFigmaPaywall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 4V8M10 4H8.02438C6.90635 4 6 4.90635 6 6.02438C6 7.16222 6.93748 8.07656 8.07497 8.04813L10 8M10 4H12C13.1046 4 14 4.89543 14 6C14 7.10457 13.1046 8 12 8H10M10 12V14C10 15.1046 9.09167 16 7.9871 16C6.89669 16 6 15.116 6 14.0256C6 12.9544 6.85417 12.0786 7.92503 12.0519L10 12ZM10 12V8M10 12H8C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8H10M10 12H12.0256C13.116 12 14 11.116 14 10.0256C14 8.95444 13.1458 8.07865 12.075 8.05187L10 8",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgFigmaPaywall;
